import type { EstimatedRange } from '#/modules/salaries/types/EstimatedRange';
import { SALARIES_API_ENDPOINT_ROOT } from '#/modules/salaries/utils/constants/salariesApiEndpointRoot';
import type { BackgroundTask } from '#/utils/asyncBackendTask/asyncBackendTaskTypes';
import { waitTaskCompleted } from '#/utils/asyncBackendTask/waitTaskCompleted';
import { postJson } from '#/utils/http/postJson';

export async function salariesFetchCareerPathSynonyms({
  selectedSynonymId,
  city,
  stateCode,
  yearsOfExperience,
}: {
  selectedSynonymId: string | null;
  city?: string;
  stateCode?: string;
  yearsOfExperience?: number;
  useMock?: boolean;
}): Promise<EstimatedRange[]> {
  const { task } = await postJson<{
    task: BackgroundTask<{ careerPath: EstimatedRange[] }>;
  }>(`${SALARIES_API_ENDPOINT_ROOT}/calculator/career-path/initial`, {
    city,
    stateCode,
    yearsOfExperience,
    selectedSynonymId,
  });

  const { careerPath } = await waitTaskCompleted(task);
  return careerPath;
}
